const ExecutionEnvironment = {
  isSsr: Boolean(typeof window === 'undefined' || !window.document || !window.document.createElement),
}

export { ExecutionEnvironment }
